import BASE_CONFIG, { type AppConfig } from '../config.base';

const prodConfig = {
  services: {
    account: {
      ...BASE_CONFIG.services.account,
      baseUrl: 'https://forbusiness-api.geappliances.com/account-prd',
    },
    user: {
      ...BASE_CONFIG.services.user,
      baseUrl: 'https://forbusiness-api.geappliances.com/userAccount-prd',
    },
    order: {
      ...BASE_CONFIG.services.order,
      baseUrl: 'https://forbusiness-api.geappliances.com/order-prd',
    },
    finance: {
      ...BASE_CONFIG.services.finance,
      baseUrl: 'https://forbusiness-api.geappliances.com/finance-prd',
    },
    product: {
      ...BASE_CONFIG.services.product,
      baseUrl: 'https://forbusiness-api.geappliances.com/product-prd',
    },
    shopping: {
      ...BASE_CONFIG.services.shopping,
      baseUrl: 'https://forbusiness-api.geappliances.com/shopping-prd',
    },
    customerNetSpringBoot: {
      ...BASE_CONFIG.services.customerNetSpringBoot,
      baseUrl: 'https://customernetapi.geappliances.com/api/cnet',
    },
    customerNetCustomer: {
      ...BASE_CONFIG.services.customerNetCustomer,
      baseUrl: 'https://cnet.api.geappliances.io/customers-prd',
    },
    customerNetProduct: {
      ...BASE_CONFIG.services.customerNetProduct,
      baseUrl: 'https://cnet.api.geappliances.io/products-prd',
    },
    customerNetUser: {
      ...BASE_CONFIG.services.customerNetUser,
      baseUrl: 'https://cnet.api.geappliances.io/users-prd',
    },
    customerNetOrder: {
      ...BASE_CONFIG.services.customerNetOrder,
      baseUrl: 'https://cnet.api.geappliances.io/orders-prd',
    },
    customerNetPartsSpringBoot: {
      ...BASE_CONFIG.services.customerNetPartsSpringBoot,
      baseUrl: 'https://partsnetapi.geappliances.com/api/pnet',
    },
  },
  integrations: {
    ...BASE_CONFIG.integrations,
    customernetUrl: 'https://geappliancescustomernet.com',
    legacyLoginUrl:
      'https://sso.geappliances.com/samlp/zUgJEfhanCf9UYa8zDwCYuyVXHVT6aqA',
    legacyLogoutUrl:
      'https://sso.geappliances.com/v2/logout?client_id=zUgJEfhanCf9UYa8zDwCYuyVXHVT6aqA&returnTo=https://forbusiness.geappliances.com',
    oktaLoginUrl:
      'https://geappliances.okta.com/app/geappliances_forbusinessprod_1/exk11ptpbl7R4mLgi698/sso/saml',
    botIframeUrl: 'https://customer360.geappliances.com',
    cyberSource: {
      requestToUrl:
        'https://secureacceptance.cybersource.com/embedded/token/create',
      responseToUrl:
        'https://cnet.api.geappliances.io/node-prd/response?sourceSystem=dpm',
      accessKey: '780e77916ffd353da4a78645e3a45f85',
      profileId: '7B12FFE0-F47F-4872-A7C2-96A5ABCA5E25',
    },
  },
  constants: {
    pricingJobIntervalDays: 1,
    dpmData: {
      fallbackAccountNumber: '121846403',
      fallbackSalesAgreementNumber: 223799,
    },
  },
  assets: {
    ...BASE_CONFIG.assets,
  },
} satisfies AppConfig;

export default prodConfig;
